/**
 * Created by spepa on 15.12.2020
 */

cleverapps.styles.COLORS = cleverapps.overrideColors(cleverapps.styles.COLORS, {
    COLOR_WINDOW_TEXT: new cc.Color(169, 61, 32, 255),
    DARK_TEXT_COLOR: new cc.Color(169, 61, 32, 255),

    MOVES_DANGER: new cc.Color(255, 0, 0, 255),
    PATH_COLOR: new cc.Color(255, 230, 180, 255),
    LETTER: new cc.Color(94, 24, 89, 255),

    COLOR_LIGHTBROWN: new cc.Color(200, 171, 124, 255),

    COLOR_LIGHT_WINDOW_TEXT: new cc.Color(160, 100, 70, 255),

    COLOR_VICTORY: new cc.Color(253, 217, 61, 255),

    GOAL_NOT_DONE_COLOR: new cc.Color(255, 100, 100, 255),

    BOMB_TIMER_DANGER_COLOR: new cc.Color(255, 50, 50, 255),

    HARD: new cc.Color(255, 241, 226, 255),

    GREEN: new cc.Color(90, 166, 58, 255),
    DARK_BLUE: new cc.Color(15, 100, 172, 255),
    COLOR_BROWN: new cc.Color(187, 91, 45, 255),
    COLOR_BROWN_2: new cc.Color(173, 61, 0, 255),
    COLOR_VIOLET: new cc.Color(255, 30, 252, 255),
    COLOR_DARK_VIOLET: new cc.Color(139, 0, 156, 255),
    LIGHT_PURPLE: new cc.Color(208, 0, 255, 255),
    ORANGE: new cc.Color(255, 115, 0, 255),
    COLOR_BONUS: new cc.Color(215, 169, 255, 255),
    MENUBAR_TIMER_COLOR: new cc.Color(33, 193, 255, 255),
    SETTINGS_WINDOW_TEXT_COLOR: new cc.Color(169, 61, 32, 255),
    TOOLTIP_TEXT: new cc.Color(161, 69, 41, 255),
    ISLAND_DECORATION_ITEM: new cc.Color(46, 99, 169, 255)
});

if (typeof ColorComponent !== "undefined") {
    cleverapps.styles.COLORS.CELL_COLORS = {};
    cleverapps.styles.COLORS.CELL_COLORS[ColorComponent.COLOR_A] = new cc.Color(20, 160, 237, 255);
    cleverapps.styles.COLORS.CELL_COLORS[ColorComponent.COLOR_B] = new cc.Color(20, 200, 0, 255);
    cleverapps.styles.COLORS.CELL_COLORS[ColorComponent.COLOR_C] = new cc.Color(195, 61, 225, 255);
    cleverapps.styles.COLORS.CELL_COLORS[ColorComponent.COLOR_D] = new cc.Color(255, 11, 28, 255);
    cleverapps.styles.COLORS.CELL_COLORS[ColorComponent.COLOR_E] = new cc.Color(234, 199, 48, 255);
    cleverapps.styles.COLORS.CELL_COLORS[ColorComponent.COLOR_W] = new cc.Color(50, 200, 255, 255);
}

cleverapps.overrideStyles(cleverapps.styles.UI.Button, {
    keepRadius: true,

    maxFontSize: 71,
    defaultSize: 78
});

cleverapps.overrideStyles(cleverapps.styles.DECORATORS, {
    WINDOW_TITLE_STROKE: {
        color: new cc.Color(168, 28, 54, 255),
        size: 4
    },
    TITLE_TEXT_SHADOW: {
        color: cleverapps.styles.COLORS.BLACK,
        direction: cc.size(0, -4),
        blur: 5
    },
    IMAGE_FONT_STROKE: {
        color: cleverapps.styles.COLORS.BLACK_STROKE,
        size: 2
    },
    IMAGE_FONT_STROKE_THIN: {
        color: cleverapps.styles.COLORS.BLACK_STROKE,
        size: 1
    },

    BROWN_STROKE: {
        color: cleverapps.styles.COLORS.COLOR_BROWN_2,
        size: 3
    },

    BUTTON_TEXT_STROKE: {
        color: new cc.Color(217, 0, 68, 255),
        size: 3
    },

    TILE_SHOP_BADGE_STROKE: {
        color: new cc.Color(84, 174, 33, 255),
        size: 3
    },

    LANTERN_START_COMPONENT_STROKE: {
        color: cleverapps.styles.COLORS.DARK_BLUE
    },

    LEADERS_STROKE: {
        color: new cc.Color(244, 233, 217, 255),
        size: 2
    },

    FEAST_MISSION_TIMER_STROKE: {
        color: cleverapps.styles.COLORS.BLACK_STROKE,
        size: 2
    },

    ISLAND_DECORATION_STROKE: {
        color: new cc.Color(6, 116, 234, 255),
        size: 2
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    MISSION_START_WINDOW_TEXT: {
        name: "nostroke"
    },

    LEVELUPWINDOW_VALUE_TEXT: {
        size: 220,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: {
            color: new cc.Color(0, 0, 0, 50),
            size: 2
        },
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    LEVELUPWINDOW_REWARD_TEXT: {
        name: "big_digits",
        size: 74,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    LOADING_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(147, 36, 64, 255),
            size: 2
        }
    },
    WHITE_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE
    },
    MENUBAR_TEXT_DELTA: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    SMALL_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        name: "nostroke"
    },
    WINDOW_BIG_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    TOOLBAR_ITEM_TIMER_TEXT: {
        size: 23
    },
    LOADING_ANIMATION_TEXT: {
        size: 50,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },
    TILE_SHOP_OFFER_TEXT: {
        name: "nostroke",
        size: 60,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    // Old riddles had no PACK_TILE_REWARDS_TEXT, so pack/offer rewards fell back to the nostroke,
    // size-60 TILE_SHOP_OFFER_TEXT above. The prefab tiles bind PACK_TILE_REWARDS_TEXT directly
    // (base = default font, size 40, with stroke), so restore the old nostroke/60 here. omitting
    // stroke clears the base IMAGE_FONT_STROKE (overrideFonts copies stroke unconditionally).
    PACK_TILE_REWARDS_TEXT: {
        name: "nostroke",
        size: 60
    },

    SHOP_WINDOW_LIVES_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    LANTERN_TIMER_FONT: {
        name: "nostroke",
        size: 35,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    TILE_REWARDS: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    TILE_REWARDS_HEADER: {
        size: 35,
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    PRODUCT_TILE_LIMIT_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    MENUBAR_TEXT: {
        name: "nostroke",
        size: 60,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    MENUBAR_LEVEL_TEXT: {
        name: "nostroke",
        size: 66,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    TILE_SHOP_BADGE_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    TILE_SHOP_BADGE_BIG: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    SHOP_WINDOW_TILE_TITLE: {
        size: 65,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    SHOP_WINDOW_SMALL_TILE_TITLE: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    SIDEBAR_ICON_TEXT: {
        name: "nostroke",
        size: 38,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    SIDEBAR_ICON_PROGRESS: {
        size: 36,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    EXTRABAR_ICON_TEXT: {
        name: "nostroke",
        size: 28,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    EPISODE_CLOUD_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_BLUE
    },

    INC_MOVES_TEXT: {
        name: "default",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_BROWN
    },

    BUSTER_NOTIFICATION_TEXT: {
        size: 34,
        color: cleverapps.styles.COLORS.WHITE
    },

    CONGRATE_TEXT: {
        size: 100,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(255, 203, 78, 255),
            size: 3
        }
    },

    REWARDS_LIST_TEXT: {
        name: "nostroke",
        size: 36,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    MENUBAR_TIMER_TEXT: {
        name: "nostroke",
        size: 48,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    MENUBAR_PREMIUM_STICKER_TEXT: {
        size: 24,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(216, 27, 106, 255),
            size: 2
        }
    },

    SHOP_LIVES_PRODUCT_TILE_DESCRIPTION_TEXT: {
        name: "nostroke",
        size: 39,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    TILE_SHOP_COINS_OFFER: {
        size: 70,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    TOOLTIP_TEXT: {
        color: cleverapps.styles.COLORS.TOOLTIP_TEXT
    },
    TOOLTIP_REWARDS_FONT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.TOOLTIP_TEXT
    },

    VICTORY_CHEST_TEXT: {
        name: "nostroke",
        size: 48,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    // ---

    VERY_BIG_TEXT: {
        name: "nostroke",
        size: 80,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    EPISODE_TITLE_TEXT: {
        size: 80,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    DESCRIPTION_TEXT: {
        size: 23,
        color: cleverapps.styles.COLORS.COLOR_LIGHTBROWN
    },

    ADDMOVES_GOAL_RED_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.GOAL_NOT_DONE_COLOR
    },

    TIMER_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },

    DEC_MOVES_TEXT: {
        name: "default",
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_RED
    },

    SUBSCRIPTION_BUTTON_TITLE: {
        size: 22,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    SUBSCRIPTION_MAIN_TEXT: {
        size: 32,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    TERMS_LINK_TEXT: {
        size: 26,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    TERMS_TEXT: {
        size: 22,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    GAME_MESSAGE_TEXT: {
        size: 86,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    REWARDS_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    PACKWINDOW_LABEL_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },
    BOMB_TIMER_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.RIDDLES_BROWN,
        size: 30
    },
    BOMB_TIMER_DANGER_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.BOMB_TIMER_DANGER_COLOR
    },
    CELL_LIVES: {
        size: 35,
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    LOSE_WINDOW_TEXT: {
        color: cleverapps.styles.COLORS.WHITE,
        size: 50
    },
    WINDOW_SMALL_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    TOURNAMENT_PLAYER_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    WINDOW_TITLE_TEXT: {
        size: 71,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.WINDOW_TITLE_STROKE
    },

    NOBG_WINDOW_TITLE_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: {
            color: new cc.Color(155, 39, 15, 255),
            size: 2
        },
        shadow: {
            color: new cc.Color(155, 39, 15, 255),
            direction: cc.size(0, -2)
        }
    },

    BUTTON_SMALL_TEXT: {
        size: 34,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },
    WINDOW_TEXT: {
        size: 50,
        name: "nostroke",
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    FBCONNECT_WINDOW_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    HERO_UPGRADE: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE_THIN
    },
    HERO_ABILITIES_TEXT: {
        name: "nostroke",
        size: 30,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE_THIN
    },
    FORCE_MESSAGE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_BROWN
    },
    MENUBAR_PROGRESS_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR
    },
    QUEST_PROGRESS_TEXT: {
        name: "nostroke",
        size: 48,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    DIALOGUE_PERSON_TITLE_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        shadow: undefined,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE
    },
    LIGHT_TITLE_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.WINDOW_TITLE_STROKE,
        shadow: undefined
    },
    UNITICON_LEVEL: {
        size: 30,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },
    HERODETAILS_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },
    DARK_TEXT: {
        name: "nostroke",
        size: 45,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },
    LIGHT_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    UNIT_PROB: {
        size: 35,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    BUYINGREDIENTSWINDOW_TITLE: {
        name: "default",
        size: 45,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },
    ORDERS_PLACEHOLDER_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    UNITSSHOP_CART_AMOUNT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },
    TRAVEL_BOOK_MESSAGE_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },
    TRAVEL_BOOK_BOTTOM_TEXT: {
        name: "default",
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    TRAVEL_BOOK_TITLE_TEXT: {
        name: "default",
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    CLANS_ROW_NAME_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    CLANS_ROW_LEADER_TEXT: {
        size: 60
    },

    CLAN_CHAT_PHRASE: {
        size: 40,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    CLAN_CHANGE_EMBLEM_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    CLAN_PROPERTY_TEXT: {
        size: 52,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },

    CLAN_SETTING_TEXT: {
        size: 50,
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        stroke: cleverapps.styles.DECORATORS.LIGHT_TEXT_STROKE,
        shadow: cleverapps.styles.DECORATORS.LIGHT_TEXT_SHADOW
    },

    TABS_TEXT_FONT: {
        size: 40,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        shadow: undefined,
        stroke: undefined
    },

    TABS_TEXT_FONT_DISABLED: {
        size: 40,
        color: new cc.Color(254, 241, 226, 255),
        shadow: undefined,
        stroke: {
            color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
            size: 1
        }
    },

    DELETE_ACCOUNT_TEXT: {
        size: 35,
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR,
        stroke: undefined,
        shadow: undefined
    },
    GOAL_TEXT: {
        size: 30
    },

    KINGSCUP_MARKS_TEXT: {
        size: 30
    },

    LIGHTNING_RUSH_MARKS_TEXT: {
        size: 30
    },

    MOVES_CELL_TEXT: {
        size: 35
    },

    SHOP_USER_GOLD_TEXT: {
        name: "nostroke",
        size: 40,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT
    },

    LANTERN_WINDOW_TEXT: {
        size: 29,
        color: new cc.Color(190, 90, 60, 255)
    },

    NOADS_BONUS_TEXT: {
        color: cleverapps.styles.COLORS.LIGHT_TEXT_COLOR,
        size: 60
    },

    DANGER_COMPONENT: {
        color: new cc.Color(144, 49, 192, 100)
    },

    ROW_PLAYER_TEXT: {
        name: "lightstroke",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    ROW_TEXT: {
        name: "lightstroke",
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    },

    ROW_SCORE_TEXT: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE
    },

    UNITFAMILY_TITLE: {
        size: 50,
        color: cleverapps.styles.COLORS.COLOR_WINDOW_TEXT,
        stroke: undefined,
        shadow: undefined
    },

    DUPLICATE_TEXT: {
        size: 30
    },

    DUPLICATE_TEXT_RARE: {
        size: 30
    },

    SETTINGS_WINDOW_NAME_TEXT: {
        name: "nostroke",
        size: 50,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    SETTINGS_WINDOW_ID_TEXT: {
        name: "nostroke",
        size: 34,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    SETTINGS_WINDOW_FOLLOW_US_TEXT: {
        name: "nostroke",
        size: 58,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    SETTINGS_BUTTON_TEXT: {
        size: 61,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_3PX
    },

    SETTINGS_WINDOW_VERSION_TEXT: {
        name: "nostroke",
        size: 43,
        color: cleverapps.styles.COLORS.SETTINGS_WINDOW_TEXT_COLOR
    },

    PROFILE_WINDOW_NICKNAME_GENERATOR_NICKNAME_TEXT: {
        size: 40,
        color: new cc.Color(240, 139, 138, 255)
    },

    MENUBAR_TOOLTIP_TEXT: {
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    MENUBAR_TOOLTIP_NUMBERS_TEXT: {
        name: "nostroke",
        color: cleverapps.styles.COLORS.DARK_TEXT_COLOR
    },

    PROFILE_WINDOW_NICKNAME_GENERATOR_PREFIX_TEXT: {
        size: 50
    },

    PROFILE_WINDOW_AVATAR_PICKER_TEXT: {
        size: 44
    },

    LEADERS_MAIN_TITLE_TEXT: {
        size: 78,
        color: new cc.Color(173, 61, 0, 255),
        stroke: cleverapps.styles.DECORATORS.LEADERS_STROKE
    },

    LEADERS_TIMER_TEXT: {
        name: "nostroke",
        size: 52,
        color: new cc.Color(177, 58, 14, 255)
    },

    PRIZE_BAR_TEXT: {
        size: 40
    },

    STICKERS_PROGRESS_BAR_TEXT: {
        size: 40
    },

    BONUSSALE_PRODUCT_REWARD: {
        size: 50
    },

    UNITSSHOPTILE_AMOUNT: {
        size: 68
    },

    UNITSSHOP_BOTTOM_TIMER: {
        size: 60
    },

    LANDMARK_PROGRESS_FONT: {
        size: 55
    },

    SINGLE_PRODUCT_OFFER_CLPASS_REWARD: {
        size: 60
    }
});

if (cleverapps.styles.BackgroundsWindow) {
    cleverapps.overrideStyles(cleverapps.styles.BackgroundsWindow, {
        padding: {
            bottom: 0
        },

        item: {
            size: {
                vertical: {
                    width: 443,
                    height: 633
                },
                horizontal: {
                    width: 600,
                    height: 350
                }
            },
            bg: {
                padding: {
                    x: 13,
                    y: 14
                },
                x: { align: "center" },
                y: { align: "center", dy: 4 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.MenuBarItem, {
    bg: {
        width: 265,
        height: 80,
        timerHeight: 122,
        minWidth: 247,
        padding: {
            right: 16,
            top: 0,
            bottom: 2
        }
    },

    items: {
        LivesItem: {
            bg: {
                width: 291
            }
        },

        WorkersItem: {
            bg: {
                width: 291
            }
        }
    },

    icon: {
        x: 15
    },

    plusButton: {
        offset: {
            x: -15,
            y: -3
        }
    },

    iconText: {
        position: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 6 }
        }
    },

    attention: {
        x: { align: "right", dx: 7 },
        y: { align: "bottom", dy: -18 }
    },

    timer: {
        x: { align: "center", dx: 23 },
        y: { align: "bottom", dy: 8 }
    },

    premiumSticker: {
        y: { align: "center", dy: 45 }
    }
});

cleverapps.override(cleverapps.styles.SettingsWindow, {
    margin: 15,
    textOpacity: 170,

    contentPadding: {
        x: 30
    },

    user: {
        padding: {
            top: 5,
            bottom: 10
        }
    },

    invite: {
        position: [{
            x: { align: "right", dx: -15 },
            y: { align: "top", dy: -15 }
        }, {
            x: { align: "right", dx: -15 },
            y: { align: "top", dy: -15 }
        }, {
            x: { align: "right", dx: -15 },
            y: { align: "top", dy: -15 }
        }]
    },

    avatar: {
        position: {
            x: { align: "left", dx: 0 },
            y: { align: "center" }
        },

        externalPosition: {
            x: { align: "left", dx: 20 },
            y: { align: "center" }
        },

        padding: {
            top: 20,
            bottom: 20,
            right: 10,
            left: 30
        },

        size: {
            width: 185,
            height: 195
        }
    },

    button: {
        width: 555,
        height: 125,

        text: {
            width: 405,
            height: 100
        }
    },

    grid: {
        margin: {
            x: 100,
            y: 18
        }
    },

    controlButton: {
        width: 110,
        height: 100
    }
});

cleverapps.overrideStyles(cleverapps.styles.MenuBarTextView, {
    noColoredText: true,

    amountText: {
        dy: 1
    }
});

cleverapps.overrideStyles(cleverapps.styles.CloseButton, {
    scale: [0.8, 1, 1],
    position: [{
        x: { align: "right", dx: -18 },
        y: { align: "top", dy: -15 }
    }, {
        x: { align: "right", dx: -25 },
        y: { align: "top", dy: -22 }
    }, {
        x: { align: "right", dx: -25 },
        y: { align: "top", dy: -22 }
    }]
});

cleverapps.overrideStyles(cleverapps.styles.Window, {
    minHeight: 400,
    minWidth: 300,

    border: {
        scale: [0.75, 1, 1],
        top: 114,
        left: 22,
        right: 22,
        bottom: 28
    },
    padding: {
        top: 40,
        left: 30,
        right: 30,
        bottom: 30
    },

    HelpButton: {
        scale: [0.75, 1, 1],
        position: [{
            x: { align: "left", dx: 35 },
            y: { align: "top", dy: -30 }
        }, {
            x: { align: "left", dx: 40 },
            y: { align: "top", dy: -40 }
        }, {
            x: { align: "left", dx: 40 },
            y: { align: "top", dy: -40 }
        }],
        zOrder: 3
    },

    BottomButton: {
        height: 110
    },

    Background: {
        padding: {
            x: -13
        }
    },

    Foreground: {
        padding: {
            top: 96,
            left: 0,
            right: 0,
            bottom: 0
        }
    },

    BoundingBoxPadding: {
        x: 25,
        y: 25
    },

    windowShowUpAnimation: {
        name: "defaultRiddles"
    }
});

cleverapps.overrideStyles(cleverapps.styles.Tabs, {
    margin: 10,

    buttons: {
        width: 127,
        height: 96,

        padding: {
            bottom: 15
        },

        disabled: {
            opacity: 255
        }
    },

    attention: {
        x: { align: "left", dx: -20 },
        y: { align: "top", dy: -5 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.TileBadge, {
    x: { align: "center", dx: 0 },
    y: { align: "center", dy: 5 },
    width: 115,
    rotation: 20
});

cleverapps.overrideStyles(cleverapps.styles.FriendRequestView, {
    Icon: {
        x: 223
    }
});

cleverapps.overrideStyles(cleverapps.styles.DefaultTableStyles, {
    barPadding: {
        cornerPadding: 5
    },
    margin: -4
});

cleverapps.overrideStyles(cleverapps.styles.PrizeBarComponent, {
    prize: {
        x: { align: "right", dx: 50 },
        y: { align: "center", dy: 5 }
    },
    mark: {
        x: { align: "right", dx: 36 }
    }
});

[
    cleverapps.styles.UI.Button.Images.control_button,
    cleverapps.styles.UI.Button.Images.back_button
].forEach((type) => {
    cleverapps.overrideStyles(type, {
        mark: {
            x: { align: "right", dx: 12 },
            y: { align: "top", dy: 7 }
        }
    });
});

cleverapps.overrideStyles(cleverapps.styles.Timer, {
    width: 280
});

cleverapps.overrideStyles(cleverapps.styles.SubscriptionButtons, {
    buttonHeight: 110
});

cleverapps.overrideStyles(cleverapps.styles.LevelStartWindow, {
    Button: {
        height: 110
    }
});

cleverapps.overrideStyles(cleverapps.styles.LoseWindow, {
    noBackground: true,
    button: {
        height: 110
    }
});

cleverapps.overrideStyles(cleverapps.styles.MinimalDialogue, {
    person: {
        margin: 20
    },

    text: {
        arrow: {
            left: {
                x: { align: "left", dx: -24 },
                y: { align: "center", dy: 0 }
            },
            right: {
                x: { align: "right", dx: 24 },
                y: { align: "center", dy: 0 }
            }
        }
    }
});

if (cleverapps.styles.BoosterBeforeAmountView) {
    cleverapps.overrideStyles(cleverapps.styles.BoosterBeforeAmountView, {
        amount: {
            x: { align: "center", dx: 2 },
            y: { align: "center", dy: 4 }
        }
    });
}

if (cleverapps.styles.BoosterBeforeView) {
    cleverapps.overrideStyles(cleverapps.styles.BoosterBeforeView, {
        bonus: {
            x: { align: "left", dx: -10 }
        },

        amount: {
            x: { align: "right", dx: 10 }
        },

        icon: {
            "5": { dy: 3 },
            "6": { dy: 4 },
            "7": { dy: 5 }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RateWindow, {
    width: 700,
    height: 240,

    button: {
        width: 300,
        height: 110
    },

    stars: {
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: 280 }
    }
});

if (cleverapps.styles.DailyCupView) {
    cleverapps.overrideStyles(cleverapps.styles.DailyCupView, {
        title: {
            width: 610,

            bg: {
                x: { align: "center" },
                y: { align: "center", dy: -45 }
            },

            text: {
                width: 500,

                y: { align: "center", dy: -18 }
            }
        }
    });
}

if (cleverapps.styles.ExtendUnlimitedLivesWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ExtendUnlimitedLivesWindow, {
        animation: {
            height: 250,

            y: { align: "center", dy: -20 }
        },
        button: {
            height: 110
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.AllDoneWindow, {
    button: {
        height: 110
    }
});

cleverapps.overrideStyles(cleverapps.styles.ChatHeader, {
    text: {
        offsetY: 10
    }
});

if (cleverapps.styles.ProlongationOfferView) {
    cleverapps.overrideStyles(cleverapps.styles.ProlongationOfferView, {
        button: { height: 110 },

        label: {
            amount: {
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: 0 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.WindowTitle.Types, {
    bg_window: {
        scale: [0.8, 1, 1],

        background: undefined,

        titleSideOffset: {
            x: 100
        },

        text: {
            y: { align: "center", dy: 22 }
        },

        position: [{
            x: { align: "center" },
            y: { align: "top", anchor: false, dy: -60 }
        }, {
            x: { align: "center" },
            y: { align: "top", anchor: false, dy: -80 }
        }, {
            x: { align: "center" },
            y: { align: "top", anchor: false, dy: -80 }
        }]
    },

    nobg_window: {
        fontSize: [50, 60, 60],
        background: {
            height: 160
        },
        text: {
            y: { align: "center", dy: 28 }
        }
    }
});

if (cleverapps.styles.AvatarMenuBarView) {
    cleverapps.overrideStyles(cleverapps.styles.AvatarMenuBarView, {
        height: 91,

        level: {
            x: { align: "left", dx: -20 },
            y: { align: "bottom", dy: -17 },
            scale: [1.25, 1, 1],
            text: {
                x: { align: "center", dx: -1 },
                y: { align: "center", dy: -5 }
            },

            collections: {
                x: { align: "left", dx: -15 },
                y: { align: "bottom", dy: -36 },
                text: {
                    x: { align: "center", dx: -1 },
                    y: { align: "center", dy: 5 }
                }
            }
        },

        avatar: {
            x: { align: "center" },
            y: { align: "top" },

            size: {
                width: 185,
                height: 195
            },

            mobileSize: [{
                width: 163,
                height: 173
            }, {
                width: 185,
                height: 195
            }, {
                width: 185,
                height: 195
            }],

            padding: 0
        },

        progress: {
            x: { align: "center", dx: 20 },
            y: { align: "bottom", dy: -2 },

            width: 130,
            mobileWidth: [117, 130, 130]
        },

        toolTipContent: {
            margin: 20
        }
    });
}

if (cleverapps.styles.QuestsTableView) {
    cleverapps.overrideStyles(cleverapps.styles.QuestsTableView, {
        size: {
            width: 210,
            height: 600
        }
    });
}

if (cleverapps.styles.UnitsLibraryWindow) {
    cleverapps.overrideStyles(cleverapps.styles.UnitsLibraryWindow, {
        withTitle: true,

        size: [{
            width: 936,
            height: 1200
        }, {
            width: 1378,
            height: 950
        }, {
            width: 1378,
            height: 950
        }],

        padding: {
            x: 34,
            y: 18
        },

        tabs: {
            position: [{
                x: { align: "left", dx: 60 },
                y: { align: "bottom", dy: -126 }
            }, {
                x: { align: "left", dx: 60 },
                y: { align: "bottom", dy: -102 }
            }, {
                x: { align: "left", dx: 60 },
                y: { align: "bottom", dy: -102 }
            }],
            direction: cleverapps.UI.HORIZONTAL,
            type: Tabs.Types.tabs_bottom,
            size: [{
                width: 148,
                height: 142
            }, {
                width: 188,
                height: 122
            }, {
                width: 188,
                height: 122
            }],
            margin: [{ margin: -15 }, { margin: 0 }, { margin: 0 }],
            iconMaxScale: [1.2, 1, 1],
            changeIconColor: false,
            changeIconOpacity: true,

            selectAnimation: "riddles",

            attention: {
                x: { align: "left", dx: 10 },
                y: { align: "bottom", dy: -15 }
            }
        },

        window: {
            Foreground: {
                padding: {
                    left: 0,
                    right: 0,
                    bottom: 0
                }
            }
        }
    });
}

if (cleverapps.styles.FamilyLayout) {
    cleverapps.overrideStyles(cleverapps.styles.FamilyLayout, {
        title: {
            x: { align: "left", dx: 40 },
            y: { align: "top", dy: -5 }
        },

        grid: {
            position: {
                x: { align: "left", dx: 0 },
                y: { align: "center", dy: -40 }
            },

            padding: {
                x: 20,
                top: 40,
                bottom: 60
            },

            separator: {
                x: { align: "center" },
                y: { align: "top", dy: -75 }
            }
        },

        progress: {
            x: { align: "right", dx: -30 },
            y: { align: "top", dy: -14 },
            width: 400
        }
    });
}

if (cleverapps.styles.HeroDetailsLayout) {
    cleverapps.overrideStyles(cleverapps.styles.HeroDetailsLayout, {
        height: 400,

        buttonInfo: {
            x: { align: "left", dx: 234 },
            y: { align: "top", dy: -124 }
        },

        title: {
            x: { align: "left", dx: 40 },
            y: { align: "top", dy: -5 }
        },

        grid: {
            size: [{ width: 576 }, { width: 1006 }, { width: 1006 }],

            position: {
                x: { align: "left", dx: 310 },
                y: { align: "center", dy: -40 }
            },

            scroll: {
                x: { align: "left", dx: 310 },
                y: { align: "center", dy: -40 }
            },

            margin: {
                x: 44,
                y: 20
            },

            padding: {
                x: 20,
                top: 40,
                bottom: 60
            }
        },

        infoHeroText: {
            x: { align: "center", dx: 150 },
            y: { align: "center", dy: -26 },

            size: [{ width: 576, height: 280 }, { width: 1006, height: 280 }, { width: 1006, height: 280 }]
        },

        heroIcon: {
            position: {
                x: { align: "left", dx: 20 },
                y: { align: "bottom", dy: 20 }
            }
        }
    });
}

if (cleverapps.styles.UnitLibraryIcon) {
    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIcon, {
        footer: false
    });
}

if (cleverapps.styles.UnitLibraryIconBg) {
    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIconBg, {
        width: 175,
        height: 176,

        selected: {
            width: 191,
            height: 192
        },

        prize: {
            x: { align: "center" },
            y: { align: "center" }
        },

        iconUnknown: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        },

        title: false
    });

    cleverapps.overrideStyles(cleverapps.styles.UnitLibraryIconFooter, {
        width: 200,
        height: 80,

        level: false,

        collectButton: {
            height: 70,
            type: cleverapps.styles.UI.Button.Images.small_button_green
        }
    });
}

if (cleverapps.styles.UnitsTab) {
    cleverapps.overrideStyles(cleverapps.styles.UnitsTab, {
        margin: 30,
        padding: {
            x: 0,
            y: 20
        }
    });
}

if (cleverapps.styles.LevelUpWindow) {
    cleverapps.overrideStyles(cleverapps.styles.LevelUpWindow["default"], {
        fireworks: {
            type: "fireworks",
            zOrder: 3
        },
        animation: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -110 }
        },

        title: undefined,

        value: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 25 },

            delay: 0.6,
            duration: 0.5
        },

        rewards: {
            x: { align: "center", dx: 10 },
            y: { align: "bottom", dy: 0 },
            direction: cleverapps.UI.HORIZONTAL,
            margin: 20,
            padding: {
                x: 90
            },

            delay: 1,
            duration: 0.4,
            small: true
        },

        rewardsBackground: {
            dy: -3,

            minWidth: 100,

            delay: 0.5
        }
    });
}

if (cleverapps.styles.HeroIcon) {
    cleverapps.overrideStyles(cleverapps.styles.HeroIcon, {
        icon: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 8 }
        },
        background: {
            scale: 1.3
        }
    });
}

if (cleverapps.styles.PrizeView) {
    cleverapps.overrideStyles(cleverapps.styles.PrizeView, {
        width: 106,
        height: 97,

        padding: {
            x: 18,
            y: 14
        },

        pointer: {
            dy: 2
        },

        animation: {
            x: { align: "center" },
            y: { align: "center", dy: 0 }
        }
    });
}

if (cleverapps.styles.QuestIcon) {
    cleverapps.overrideStyles(cleverapps.styles.QuestIcon, {
        background: {
            width: 280,
            height: 280
        },

        progress: {
            y: { align: "bottom", dy: -8 },
            width: 155,
            height: 56,
            text: {
                y: { align: "center", dy: 2 }
            }
        }
    });
}

if (cleverapps.styles.ExpInfoWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ExpInfoWindow, {
        button: {
            height: 110
        }
    });
}

if (cleverapps.styles.HeroWindow) {
    cleverapps.overrideStyles(cleverapps.styles.HeroWindow, {
        margin: 40,
        padding: {
            x: 25
        },
        activateText: {
            width: 450,
            height: 120,
            horizontalAlignment: cc.TEXT_ALIGNMENT_CENTER
        },

        descriptionText: {
            width: 450,
            height: 80,
            horizontalAlignment: cc.TEXT_ALIGNMENT_CENTER
        },

        statsBlock: {
            heroMargin: 15
        },

        canUpgrade: {
            margin: 85,
            price: {
                margin: 10,
                exp: {
                    scale: 0.6
                },
                coin: {
                    scale: 0.6
                }
            }
        },

        button: {
            height: 110
        }
    });
}

if (cleverapps.styles.CanUpgradeHeroWindow) {
    cleverapps.overrideStyles(cleverapps.styles.CanUpgradeHeroWindow, {
        button: {
            height: 110
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.LanguageButton, {
    height: 110
});

if (cleverapps.styles.StarChestWindow) {
    cleverapps.overrideStyles(cleverapps.styles.StarChestWindow, {
        content: {
            y: { align: "top", dy: -96 }
        },

        button: {
            height: 110
        },

        bar: {
            padding: {
                left: 2,
                right: 2,
                top: 2,
                bottom: 2
            }
        },

        chest: {
            y: { align: "center", dy: -7 }
        }
    });
}

if (cleverapps.styles.ConfirmSpeedUpWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ConfirmSpeedUpWindow, {
        buttons: {
            button: {
                height: 110
            }
        }
    });
}

if (cleverapps.styles.ChestPrizeProbWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ChestPrizeProbWindow, {
        padding: {
            left: -12,
            right: -16,
            top: 0,
            bottom: 0
        }
    });
}

if (cleverapps.styles.BuyIngredientsWindow) {
    cleverapps.overrideStyles(cleverapps.styles.BuyIngredientsWindow, {
        tile: {
            amountBackground: {
                width: 260,
                height: 104,
                x: { align: "center", dx: 0 },
                y: { align: "center", dy: -120 }
            },

            amountText: {
                x: { align: "center" },
                y: { align: "center", dy: -115 },
                width: 170
            },

            icon: {
                x: { align: "center" },
                y: { align: "center", dy: 45 }
            },

            title: {
                width: 260,
                x: { align: "center" },
                y: { align: "center", dy: 170 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.VIPRewardedWindow, {
    button: {
        height: 110
    },

    progress: {
        timer: {
            y: { align: "center", dy: -4 }
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.ConfirmExitWindow, {
    button: {
        height: 110
    }
});

if (cleverapps.styles.IngredientOrderIcon) {
    cleverapps.styles.IngredientOrderIcon = {
        width: 160,
        height: 160,

        padding: {
            x: 8,
            y: 2
        },

        icon: {
            x: { align: "center", dx: -10 },
            y: { align: "bottom", dy: 0 },
            scale: 2
        },

        text: {
            width: 130,
            x: { align: "right", dx: 0 },
            y: { align: "bottom", dy: -10 }
        }
    };
}

cleverapps.overrideStyles(cleverapps.styles.DialogueViewHorizontal, {
    arrow: {
        y: { align: "top", dy: 46 }
    },

    text: {
        padding: {
            fromWallX: 60,
            x: 90,
            y: 60
        }
    },

    title: {
        mobileY: { align: "top", anchor: false, dy: -10 }
    },

    widthPadding: 10
});

if (cleverapps.styles.ClansJoinRow) {
    cleverapps.overrideStyles(cleverapps.styles.ClansJoinRow, {
        button: {
            type: cleverapps.styles.UI.Button.Images.small_button_green
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RowView, {
    width: 1050,
    height: 141,

    paddingX: 30,

    content: {
        height: 104,
        margin: 20,
        verticalMargin: 10
    },

    avatar: {
        verticalScale: 0.9
    },

    place: {
        withBadge: {
            width: 60
        },
        width: 50
    },

    name: {
        x: { align: "left" }
    },

    prize: {
        width: 120,
        verticalWidth: 110
    },

    score: {
        width: 190,
        verticalWidth: 150,
        height: 84,

        icon: {
            x: 20
        }
    }
});

if (cleverapps.config.features.includes("playbutton")) {
    cleverapps.overrideStyles(cleverapps.styles.PlayButtonView, {
        height: 110
    });
}

if (cleverapps.styles.ExpeditionPageView) {
    cleverapps.overrideStyles(cleverapps.styles.ExpeditionPageView, {
        height: 650,

        message: {
            height: 100,
            width: 280,

            x: { align: "center", dx: 24 },
            y: { align: "top", dy: -110 },

            text: {
                x: { align: "center", dx: 25 },

                width: 220,
                height: 80
            },

            icon: {
                width: 70,
                height: 70
            },

            iconBg: {
                x: { align: "left", dx: -40 }
            }
        },

        button: {
            height: 110
        },

        image: {
            y: { align: "center", dy: 25 }
        },

        current: {
            y: { align: "bottom", dy: 45 }
        },

        timer: {
            y: { align: "bottom", dy: 155 }
        }
    });
}

if (cleverapps.styles.SnapshotBarView) {
    cleverapps.overrideStyles(cleverapps.styles.SnapshotBarView, {
        buttons: {
            width: 110,
            height: 110
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.DeleteAccountWindow, {
    info: {
        padding: {
            x: 60,
            y: 60
        }
    }
});

if (cleverapps.styles.StartEpisodeWindow) {
    cleverapps.overrideStyles(cleverapps.styles.StartEpisodeWindow, {
        button: {
            height: 110
        }
    });
}

if (cleverapps.styles.FinisherWindow) {
    cleverapps.overrideStyles(cleverapps.styles.FinisherWindow, {
        button: {
            height: 110
        }
    });
}

if (cleverapps.styles.LandmarkSelectWindow) {
    cleverapps.overrideStyles(cleverapps.styles.LandmarkSelectWindow, {
        sideOffset: 500,

        grid: {
            width: 900,
            height: 800,

            margin: {
                x: 40,
                y: 40
            },

            padding: {
                x: 15,
                y: 25
            }
        }
    });
}
if (cleverapps.styles.LandmarkSelectItem) {
    cleverapps.overrideStyles(cleverapps.styles.LandmarkSelectItem, {
        title: {
            y: {
                align: "center",
                dy: 90
            }
        },

        checkmark: {
            x: {
                align: "right",
                dx: -15
            },
            y: {
                align: "bottom",
                dy: -10
            }
        },

        minimal_dialogue: {
            scale: 0.6
        }
    });
}

if (cleverapps.styles.ProgressView) {
    cleverapps.overrideStyles(cleverapps.styles.ProgressView, {
        icon: {
            bg: {
                padding: {
                    x: 12,
                    y: 15
                }
            }
        }
    });
}

if (cleverapps.styles.CaravanTileView) {
    cleverapps.overrideStyles(cleverapps.styles.CaravanTileView, {
        width: 600,
        height: 1000,

        amount: {
            x: { align: "center" },
            y: { align: "bottom", dy: 185 }
        },

        title: {
            x: { align: "center", dx: -2 },
            y: { align: "center", dy: 15 },

            help: {
                x: { align: "center", dx: 7 },
                y: { align: "center", dy: -225 }
            },

            bg: {
                width: 620
            }
        },

        button: {
            height: 110,

            y: { align: "bottom", dy: 70 }
        },

        rewardsBlock: {
            y: { align: "bottom", dy: 192 },

            bg: {
                width: 487
            },

            icon: {
                x: { align: "center", dx: -100 }
            },

            rewards: {
                x: { align: "right", dx: -20 }
            }
        },

        person: {
            y: { align: "bottom", dy: 555 }
        }
    });
}

if (cleverapps.styles.BarrelAdsWindow) {
    cleverapps.overrideStyles(cleverapps.styles.BarrelAdsWindow, {
        item: {
            iconNode: {
                x: { align: "center" },
                y: { align: "center", dy: 100 },
                shining: false
            },

            strip: {
                width: 330,
                x: { align: "center", dx: 0 },

                amount: {
                    x: { align: "center" },
                    y: { align: "center", dy: 4 }
                }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.DialoguePersonTitleView, {
    text: {
        y: { align: "center", dy: 7 },

        padding: {
            x: 40,
            y: 10
        }
    }
});

if (cleverapps.styles.AddBombMovesWindow) {
    cleverapps.overrideStyles(cleverapps.styles.AddBombMovesWindow, {
        button: {
            height: 110
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.AdBlockWindow, {
    window: {
        padding: {
            right: 85,
            left: 85,
            top: 190
        }
    }
});

if (cleverapps.styles.PromotionSaleWindow) {
    cleverapps.overrideStyles(cleverapps.styles.PromotionSaleWindow[Offers.TYPES.PROMOTION_SALE], {
        title: {
            x: { align: "center", dx: -10 },
            y: { align: "center", dy: 315 }
        },

        header: {
            x: { align: "center", dx: -5 },
            y: { align: "center", dy: 0 }
        },

        lots: {
            y: { align: "center", dy: -98 }
        },

        description: {
            y: { align: "bottom", dy: -84 }
        },

        verticalWindow: {
            Background: {
                padding: {
                    x: 25
                }
            }
        }
    });
}

if (cleverapps.styles.PromotionSaleLot) {
    cleverapps.overrideStyles(cleverapps.styles.PromotionSaleLot[Offers.TYPES.PROMOTION_SALE], {
        height: 620,

        reward: {
            width: 410,
            height: 474,

            icons: {
                x: { align: "center" },
                y: { align: "center", dy: 10 }
            }
        },

        button: {
            y: { align: "bottom", dy: 14 }
        },

        badge: {
            x: { align: "right", dx: 82 },
            y: { align: "top", dy: 26 }
        }
    });
}

if (cleverapps.styles.TreasureBag) {
    cleverapps.overrideStyles(cleverapps.styles.TreasureBag, {
        background: false
    });
}

cleverapps.overrideStyles(cleverapps.styles.PrivacyWindow, {
    contentPadding: { x: 0, top: 125, bottom: 40 }
});

if (cleverapps.styles.TradeWindow) {
    cleverapps.overrideStyles(cleverapps.styles.TradeWindow, {
        window: {
            padding: {
                x: 50,
                top: 30,
                bottom: 25
            }
        }
    });
}

if (cleverapps.styles.PackOfferComponent && cleverapps.styles.PackOfferComponent[Offers.TYPES.STICKERS_PACK]) {
    cleverapps.overrideStyles(cleverapps.styles.PackOfferComponent[Offers.TYPES.STICKERS_PACK], {
        offsetY: 370,
        pack: {
            badge: {
                x: { align: "right", dx: 20 },
                y: { align: "top", dy: 25 },
                rotation: 30
            }
        },
        tap: {
            x: { align: "center", dx: 30 },
            y: { align: "center", dy: 160 },
            rotation: 0,
            scaleX: 1
        }
    });
}

if (cleverapps.styles.PackOfferComponent && cleverapps.styles.PackOfferComponent[Offers.TYPES.KRAKENFEAST]) {
    cleverapps.overrideStyles(cleverapps.styles.PackOfferComponent[Offers.TYPES.KRAKENFEAST], {
        pack: {
            offsetX: 335,
            offsetY: 210,

            title: {
                x: { align: "center", dx: 136 },
                y: { align: "center", dy: -50 },
                font: cleverapps.styles.FONTS.LIGHT_PACK_BUTTON_TEXT
            }
        },

        tap: {
            x: { align: "center", dx: -340 },
            y: { align: "center", dy: 330 }
        }
    });
}

if (cleverapps.styles.PrizeCalendarWindow) {
    cleverapps.overrideStyles(cleverapps.styles.PrizeCalendarWindow, {
        rainbowBg: {
            x: { align: "center", dx: -3 },
            y: { align: "center", dy: -30 },
            scale: 0.95
        }
    });

    cleverapps.overrideStyles(cleverapps.styles.PrizeCalendarTileView, {
        outerBg: {
            width: 170,
            height: 185
        },
        innerBg: {
            width: 145,
            height: 160
        },
        mark: {
            x: { align: "right", dx: 20 },
            y: { align: "bottom", dy: -16 }
        },
        rewards: {
            x: { align: "center" },
            y: { align: "center", dy: -10 },
            fitToBox: {
                width: 120,
                height: 120
            },
            chest: {
                x: { align: "center" },
                y: { align: "center" }
            }
        }
    });
}
if (cleverapps.styles.WheelLotteryWindow) {
    cleverapps.overrideStyles(cleverapps.styles.WheelLotteryWindow, {
        balloons: {
            y: { align: "top", dy: 0 }
        },

        table: {
            y: { align: "bottom", dy: -290 }
        },

        wheel: {
            y: { align: "center", dy: -10 }
        },

        curtains: {
            left: {
                x: { align: "left", dx: 350 },
                y: { align: "bottom", dy: 250 }
            },

            right: {
                x: { align: "right", dx: -650 },
                y: { align: "bottom", dy: 290 }
            }
        },

        note: {
            y: { align: "bottom", dy: -3 }
        }
    });
}

if (cleverapps.styles.BaseCellView) {
    cleverapps.overrideStyles(cleverapps.styles.BaseCellView, {
        lantern: {
            dx: 50,
            dy: -20
        }
    });
}

if (cleverapps.styles.UI.MovesView) {
    cleverapps.overrideStyles(cleverapps.styles.UI.MovesView, {
        lantern: {
            dx: 50,
            dy: -20
        }
    });
}

if (cleverapps.styles.QuestInfoView) {
    cleverapps.overrideStyles(cleverapps.styles.QuestInfoView, {
        regular: {
            arrow: {
                x: { align: "left", dx: -28 }
            }
        },

        compact: {
            arrow: {
                x: { align: "left", dx: -29 }
            }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RestoreProgressButton, {
    height: 110
});

if (cleverapps.styles.CustomerIngredientViewInfoView) {
    cleverapps.overrideStyles(cleverapps.styles.CustomerIngredientViewInfoView, {
        bg: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: -2 }
        },
        height: 88,
        icon: {
            offsetY: 0
        },
        progress: {
            margin: -4,

            x: { align: "right", dx: -6 },
            y: { align: "bottom", dy: -10 }
        },
        checkMark: {
            x: { align: "right", dx: 15 },
            y: { align: "bottom", dy: -2 }
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.RewardWindow, {
    rewardChest: {
        overlayPosition: {
            x: { align: "center" },
            y: { align: "center", dy: -130 }
        }
    }
});

if (cleverapps.styles.ProfileWindow) {
    cleverapps.overrideStyles(cleverapps.styles.ProfileWindow, {
        margin: 15,
        padding: {
            top: 5,
            left: 10,
            right: 10
        },

        nameGenerator: {
            width: 780,

            prefix: {
                width: 260
            },

            bg: {
                width: 415,
                height: 79,

                x: { align: "right", dx: -94 },
                y: { align: "center" },

                padding: {
                    y: 5
                }
            },

            button: {
                noBg: true
            },

            nickname: {
                offsetX: 10,
                offsetY: 0,
                line: undefined
            }
        },

        avatarPicker: {
            avatarsBox: {
                margin: { x: 80, y: 60 },
                padding: { y: 50 },

                avatar: {
                    mark: {
                        x: { align: "right", dx: 35 },
                        y: { align: "bottom", dy: -20 }
                    },

                    padding: -15
                }
            },

            scroll: {
                width: 1000,
                height: 550
            }
        },

        buttonsBox: {
            margin: 80,

            padding: {
                top: 30,
                bottom: 25
            }
        },

        button: {
            width: 380,
            height: 110
        }
    });
}

cleverapps.overrideStyles(cleverapps.styles.UI.Tooltip, {
    content: {
        padding: {
            x: 60
        }
    }
});

cleverapps.overrideStyles(cleverapps.styles.DialogueViewVertical, {
    text: {
        y: { align: "bottom", dy: 18 }
    },

    title: {
        y: { align: "top", dy: -10 }
    }
});

if (cleverapps.styles.ExtraBarIconView) {
    cleverapps.overrideStyles(cleverapps.styles.ExtraBarIconView, {
        title: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: -12 },

            width: 144,
            height: 52,
            offsetY: 4,
            factorX: 0.86,
            factorY: 1.20
        }
    });
}

if (cleverapps.styles.DonorProgressWindow) {
    cleverapps.overrideStyles(cleverapps.styles.DonorProgressWindow, {
        tabs: {
            x: { align: "left", dx: -138 },
            changeIconColor: false
        }
    });
}

if (cleverapps.styles.DonorProgressTab) {
    cleverapps.overrideStyles(cleverapps.styles.DonorProgressTab, {
        donors: {
            padding: {
                x: 55
            }
        }
    });
}

if (cleverapps.styles.LightningRushRowView) {
    cleverapps.overrideStyles(cleverapps.styles.LightningRushRowView.score, {
        height: 78
    });
}

cleverapps.overrideStyles(cleverapps.styles.UI.ImageFont, {
    SKIP_RESOLUTION: {
        DESCENTS: {
            "fonts/fredokaone": 0.1,
            "fonts/fredokaone-nostroke": 0.05
        }
    },
    lettersOffset: {
        "fonts/fredokaone": -10,
        "fonts/fredokaone-nostroke": -8
    }
});